(function () {
  // Respect user preference for reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function initLenis() {
    if (typeof Lenis === 'undefined') {
      return;
    }

    // Initialize Lenis with refined, fluid damping
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false, // Maintain native touch feel on mobile
      touchMultiplier: 1.5,
      wheelMultiplier: 1.0,
      infinite: false,
      autoResize: true,
    });

    window.lenis = lenis;

    // Animation frame loop
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Smooth scroll for in-page anchor links
    document.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[href*="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href || href === '#' || href === '#!') return;

      try {
        const url = new URL(anchor.href, window.location.href);
        if (url.pathname === window.location.pathname && url.hash) {
          const target = document.querySelector(url.hash);
          if (target) {
            event.preventDefault();
            lenis.scrollTo(target, {
              offset: -80,
              duration: 1.2,
              easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            });
            history.pushState(null, '', url.hash);
          }
        }
      } catch (e) {
        // Fallback for relative or malformed URLs
      }
    });

    // Automatically pause smooth scrolling when Shopify drawers or modals open
    const handleOverflowClass = () => {
      const isLocked =
        document.body.classList.contains('overflow-hidden') ||
        document.documentElement.classList.contains('overflow-hidden');
      if (isLocked) {
        lenis.stop();
      } else {
        lenis.start();
      }
    };

    const observer = new MutationObserver(handleOverflowClass);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // Mark scrollable drawer containers to prevent scroll hijacking inside menus/cart
    const preventSelectors = [
      '.cart-drawer__inner',
      '.menu-drawer__inner-container',
      '.facets__form',
      '.quick-add-modal__content-info',
      '.product-media-modal__content',
      'cart-drawer',
      'menu-drawer'
    ];

    const applyLenisPrevent = () => {
      preventSelectors.forEach((sel) => {
        document.querySelectorAll(sel).forEach((el) => {
          el.setAttribute('data-lenis-prevent', '');
        });
      });
    };

    applyLenisPrevent();
    document.addEventListener('shopify:section:load', applyLenisPrevent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLenis);
  } else {
    initLenis();
  }
})();
